// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__-WIbP","content":"Consent_content__3arz3","footer":"Consent_footer__2L3z8"};